// extracted by mini-css-extract-plugin
export default {"tradingHistory":"tradingHistory_tradingHistory__jEIIG"};